import SimpleParallax from 'simple-parallax-js';

// Parallax image
const parallaxImage = document.querySelectorAll('.parallax-image img');
parallaxImage.forEach(
  parallax => new SimpleParallax(parallax, {
    delay: 0,
    scale: 1.3,
  }),
);

// Parallax video
const parallaxVideo = document.querySelectorAll('.parallax-video__video');
parallaxVideo.forEach(
  parallax => new SimpleParallax(parallax, {
    delay: 0,
    scale: 1.3,
  }),
);
